import {TimeAgo, React, classNames, stringify, useContext, useAsObservableSource, useLocalStore, useEffect, observer, uiConstants, Fragment, pluralize, Popover2} from '@api'
import {Button, Popover, ButtonGroup, Spinner, Menu, MenuItem, MenuDivider, Label, Collapse, Checkbox, Icon, AnchorButton} from '@blueprintjs/core'
import {AutoRenewAnimationIconComponent, DeterminateProgressBar, ErrorBoundaryToast, FormOptionsGrid, FormOptionsGridField, FormOptionsGridFieldText, useStores, useVipLocalStore} from '@modules'
import {IPlanCollection, IVersion} from '@stores/vlp'
import {PrimaryIconButton} from 'centric-ui-components'
import {computed, action, reaction, observable, toJS, autorun, observe} from 'mobx'
import {HTMLProps} from 'react'
import * as css from './HeaderSyncIndicator.css'
import {Tooltip, Divider, ListItemText, CircularProgress} from '@material-ui/core'
import {site, nav, ISyncProgressStatus, Workspace, onSiteError, StoresInstance, useVipFlexLayoutTabStore} from '@stores'
import {VipLocalStore} from '@modules'
import {SyncIndicatorCollectionVersionStore, SyncIndicatorCollectionVersion} from './CollectionVersionSyncIndicator'
import { Tooltip2 } from '@api'
interface MyProps {
  className?: string
  location?: 'header' | 'toolbar' | 'menu'
  lastSyncTimeMap?: Map<string,any>|any,
  itemId?: string,
  isSyncIndex?: boolean
  syncId?: string
  workspace?: Workspace
  trigger?: SyncTriggers
}

export type SyncTriggers = 'library'|'modal'| 'hierarchy' | 'workspace' | 'filter'

/// region Store
class SyncIndicatorStore extends VipLocalStore {
  constructor(stores: StoresInstance,public props: MyProps) {
    super(stores)
    this.idLastSync = props.lastSyncTimeMap
    const {vlp} = this

    this.prevSeasonFilter = vlp.hierarchy.collectionVersionFilter?.selected ? toJS(vlp.hierarchy.collectionVersionFilter.selected) : null
    this.selectedSeasonFilter = vlp.hierarchy.collectionVersionFilter?.selected ?? null
    this.seasonFilterSize = vlp.hierarchy.collectionVersionFilter?.selected.size ?? null

    reaction(()=> {
      const r = {size:vlp.hierarchy.collectionVersionFilter?.selected.size, selectedSeasons:this.selectedSeasonFilter, prevSeasonFilter: this.prevSeasonFilter}
      this.prevSeasonFilter = toJS(this.selectedSeasonFilter)
      return r
    },
      ({size, selectedSeasons, prevSeasonFilter}) => {
        this.setDefaultCollectionVersionSelection(prevSeasonFilter)
      }, {name: 'Season Filter Change Reaction for sync header'})
  }

  registerEffects = () => {
    const dispose = [
      reaction(()=>{
        
      },(arg)=>{

      }, {name: 'Refresh last sync time reaction'})
      ]
    return () => dispose.forEach(d => d())
  }

  // @observable collectionVersionData = observable.map<string, ISyncProgressStatus>()


  @observable idLastSync:Map<string,any>

  prevSeasonFilter: Map<any, any>
  

  @observable selectedSeasonFilter

  @observable seasonFilterSize

  get triggeredFrom(){
    return this.props.trigger ?? null
  }

  @computed get tooltipTitle() {
    if (this.inProgress) {
      if (this.isCurrentUserSyncing) { // Don't destructure these otherwise we'll recompute on each status change even if we don't use it to draw
        return `${this.status?.percent}% completed`
      }
    }

    return this.title;
    /* if (!inProgress && isSyncIndex) {
      const {catalog: {onlineItemCount, catalogItemName}} = this
      return `${title}\n(${onlineItemCount.toLocaleString()} ${_.capitalize(pluralize(catalogItemName, onlineItemCount))})`
    } */
  }

  get isSyncIndex() { return this.props.isSyncIndex}

  @computed get title() {
    const {inProgress, strings, props: {isSyncIndex}} = this

    if (inProgress) {
      return isSyncIndex ? strings.syncIndicator.syncingIndex : strings.syncIndicator.syncingCollection
    }

    return isSyncIndex ? `${strings.syncIndicator.syncIndex}` : strings.syncIndicator.syncCollection //  ${catalog.title} Workspace
  }

  @observable collectionVersionSyncStatus = observable.map<string, ISyncProgressStatus>({}, {deep: false})

  @observable selected:Array<string> = []

  @computed get syncId() { 
    
    return this.props.syncId ?? this.triggeredFrom == 'filter' ? 
                                  this.props.itemId
                                  :(this.props.isSyncIndex ? 'workspaceSyncStatus' : this.workspaces.workspaceConfig?.syncIndicator?.syncId) 
  }

  @computed get index() { return this.props.workspace?.catalog?.index ?? this.catalog.index}

  @computed get status(): (ISyncProgressStatus & { syncInProgress: boolean }) {
    const {vlp: {hierarchy: {selected: {collections}}},
        props: {isSyncIndex}, index, stores: {syncProgress}
      } = this,
      status = syncProgress.byId.get(this.props.itemId),
      inProgressSync = isSyncIndex ? status && status?.show && (status?.itemId === index) : _.includes(collections, status?.itemId)
    if (inProgressSync) {
      return {...status, syncInProgress: true}
    } else if (status) {
      return {...status, syncInProgress: status?.show, loading: status.loading}
    }
  }

  @action onCancelSync = async (id) => {
    try {
      const {syncProgress, syncId, selectedCollectionVersion, isEmptyCollectionVersionSelection} = this
      if(id){
        syncProgress.cancelSync(id, syncId)
      }else if(this.triggeredFrom ==='hierarchy'){
        if(isEmptyCollectionVersionSelection()){
          const {vlp: {hierarchy: {selectedCollections}}} = this
          selectedCollections.forEach((collection:IPlanCollection)=>{
            syncProgress.cancelSync(collection.id, syncId)
          })
        }else{
          selectedCollectionVersion.forEach((selectedVersions, collectionId) => {
            if (!_.isEmpty(selectedVersions)) {
              selectedVersions.forEach((version) => {
                const id = collectionId + uiConstants.SEPARATOR + version.id
                syncProgress.cancelSync(id, syncId)
              })
            }
          })
        }
      }else if(this.triggeredFrom === 'workspace' || this.triggeredFrom === 'library'){
        syncProgress.cancelSync(this.index, syncId)
      }else if(this.triggeredFrom === "filter"){
        const {syncId} = this
        syncProgress.cancelSync(syncId, syncId)
      }
      
    }
    catch (err) {
      onSiteError(err)
    }
  }

  @action syncCollections = (collectionIds: Array<string>) => {
    const { syncProgress, syncId } = this
    collectionIds.forEach((collectionId) => {
      const id = collectionId
      if (!syncProgress.byId.has(id)) {
        syncProgress.onStartSync({itemId: id, syncId, versionsToSync:[]})
      }
    })
  }

  @action syncWithHierarchyFilters = ()=>{
    const{ syncId, syncProgress } = this
    console.log(syncId)
    syncProgress.onStartSync({syncId, itemId: syncId, trigger:this.triggeredFrom})
  }

  @action onStartSync = async () => {
    try {
      const {selectedCollectionVersion, props: {itemId}, syncId,
      vlp: {hierarchy: {selected: {collections}}},
        syncProgress,
        workspaceConfig
      } = this
      
    if (syncId === 'workspaceSyncStatus') {
        syncProgress.onStartSync({itemId, syncId, versionsToSync:[]})
      } else if (this.isEmptyCollectionVersionSelection()) {
        if(this.triggeredFrom =='filter'){
          this.syncWithHierarchyFilters() 
        }else{
          this.syncCollections(collections)
        }
      } else {
        if (_.isEmpty(selectedCollectionVersion)) {
          console.debug(`No collection versions selected to sync`)
        }
        selectedCollectionVersion.forEach((selectedVersions, collectionId) => {
          if (!_.isEmpty(selectedVersions)) {
            selectedVersions.forEach((version) => {
              const id = collectionId + uiConstants.SEPARATOR + version.id
              if (!syncProgress.byId.has(id)) {
                syncProgress.onStartSync({itemId:id, syncId, versionsToSync:[version.name]})
              }
            })
          }
        })
      }
      // await syncProgress.onStartSync(itemId, syncId, this.selected)
    } catch (err) {
      onSiteError(err)
    }
  }

  @computed get disablePopover() {
    const {isLoading, inProgress, isCurrentUserSyncing, isContentSyncing} = this

    return isLoading || inProgress && (!isCurrentUserSyncing || !isContentSyncing)
  }

  @computed get inProgress() {
    const {isContentSyncing, syncProgress, status, props: {isSyncIndex}} = this
    if (isSyncIndex) {
      return status?.loading === true
    }

    // old logic
    return syncProgress.inprogressIds > 0 && this.isContentSyncing
  }

  @computed get isCurrentUserSyncing() { return this.status?.cancellable }

  @computed get isCurrentCollectionSyncing() {return this.status?.itemId == this.props.itemId}

  @computed get isCurrentIndexSyncing() {
    return this.status?.itemId == this.index
  }

  @computed get isLoading() { return this.status?.loading }

  @computed get isContentSyncing() {
    const {isCurrentIndexSyncing, isCurrentCollectionSyncing, props: {isSyncIndex}} = this
    return isSyncIndex ? isCurrentIndexSyncing : isCurrentCollectionSyncing
  }

  componentWillMount() {
    const {syncProgress, props: {itemId}} = this
    setTimeout(() => syncProgress.isMerchCollectionSyncing(itemId, this.selected), 1)
  }

  selectDefault = reaction(() => {
    return {
      itemId: this.props.itemId,
      userIsAuthenticated: this.stores.authStore.userIsAuthenticated
    }
  }, async ({userIsAuthenticated}) => {
    // if (this.prevSelectedCollection !== selectedCollection) {
    //     this.prevSelectedCollection = selectedCollection
    //     return
    // }
    if (userIsAuthenticated) {
      const status = await this.syncProgress.isMerchCollectionSyncing(this.props.itemId, this.selected)
      if (!status) {
        this.selectDefaultVersions()
      }
      setTimeout(() => {
        this.getSyncQueryParams()
      }, 100)
    }
  })

  @action selectNonVersions = () => {
    this.selected = []
  }

  @computed get workspaceConfig() {
    const {catalog, props: {workspace}} = this
    return workspace?.config ?? catalog.workspaceConfig
  }

  @action selectDefaultVersions = () => {
    const {vlp: {hierarchy: {selectedCollectionVersions}}} = this,
      {workspaceConfig} = this
    this.selected = (selectedCollectionVersions?.map(version => {
      if (_.includes(workspaceConfig?.catalog?.sync?.default, version.name)) {
        return version.name
      }
    }).filter(_.identity) as any)
  }

  @action selectAllVersions = () => {
    const {vlp: {hierarchy: {selectedCollectionVersions}}} = this,
      {workspaceConfig: {catalog: {sync}}} = this

    this.selected = selectedCollectionVersions?.map(version => {
      if (sync?.showOnlyDefault && _.includes(sync?.default, version.name)) {
        return version.name
      }
      return version.name
    }).filter(_.identity)
  }



  @action getSyncQueryParams = () => {
    const {syncProgress, status, vlp} = this
    const r = syncProgress?.versions?.length && status ? syncProgress?.versions : vlp.hierarchy.versionsToSync
    this.selected = _.isEmpty(r) ? undefined : r
  }

  @action onClickVersion = (id) => {
    if (_.includes(this.selected, id)) {
      this.selected = this.selected.filter(f => f !== id)
      return
    }
    this.selected?.push(id)
  }

//********************************* */


  @observable selectedCollectionVersion: Map<string, Array<IVersion>> = new Map()

  @action setDefaultCollectionVersionSelection = (prevSeasonFilter) =>{
    const {vlp:{hierarchy}} = this
    hierarchy?.selectedCollections.forEach((collection:IPlanCollection)=>{
      this.selectNoneCollectionVersions(collection.id)
      if(!this.selectedSeasonFilter || this.selectedSeasonFilter?.size < 1){
        this.selectAllCollectionVersions(collection.id)
      }else{
        this.selectedSeasonFilter?.forEach((val:IVersion, versionNameKey) =>{
          const version = collection?.versions?.filter(v => v && (v.id == val?.id || v.name == val?.name || v.name === versionNameKey || v.id === versionNameKey))[0] ?? null
          if(version)
          {
            if(!this.selectedCollectionVersion.has(collection.id)){
              this.selectedCollectionVersion.set(collection.id,[])
            }
            let collectionVersions = this.selectedCollectionVersion.get(collection.id)
            if(_.findIndex(collectionVersions, function(v) { return v.id == version.id }) < 0){
              collectionVersions?.push(version)
            }
            if(prevSeasonFilter){
              _.keys(prevSeasonFilter).forEach((versionName)=>{
                if(!this.selectedSeasonFilter.has(versionName)){
                  collectionVersions = _.remove(collectionVersions,(version)=> version.name !==versionName)
                }
              })
            }
            this.selectedCollectionVersion.set(collection.id, collectionVersions)
          }
        })
      }
    })
  }

  @action onClickCollectionVersion = (collectionId, version:IVersion) => {
    if(!this.selectedCollectionVersion.has(collectionId)){
      this.selectedCollectionVersion.set(collectionId,[])
    }
    let collectionVersions = this.selectedCollectionVersion.get(collectionId)
    if(this.selectedCollectionVersion.has(collectionId) && _.findIndex(collectionVersions, function(v) { return v.id == version.id }) > -1){
      this.selectedCollectionVersion.set(collectionId, collectionVersions?.filter(v => v.id !== version.id))
      return
    }
    collectionVersions?.push(version)
    this.selectedCollectionVersion.set(collectionId, collectionVersions)
    // this.setSyncQueryParams()
  }

  @action selectNoneCollectionVersions = (collectionId) => {
    const {syncProgress} = this,
      selectedVersions:IVersion[] = this.selectedCollectionVersion.get(collectionId)
    selectedVersions?.forEach((version:IVersion)=>{
      const id = collectionId + uiConstants.SEPARATOR + version.id
      syncProgress?.byId?.delete(id)
    })
    this.selectedCollectionVersion.get(collectionId) && this.selectedCollectionVersion.set(collectionId, [])
    // this.setSyncQueryParams()
  }

  @action selectDefaultCollectionVersions = (collectionId) => {
    const {vlp: {hierarchy: {selectedCollections}}, workspaceConfig, syncProgress} = this

    selectedCollections?.filter(c => c.id == collectionId)?.map(collection => {
      collection?.versions.map((version)=>{
        !this.selectedCollectionVersion.has(collection.id) && this.selectedCollectionVersion.set(collection.id, [])
        let versionsArr = this.selectedCollectionVersion.get(collection.id)
        if (_.includes(workspaceConfig?.catalog?.sync?.default, version.name)) {
          versionsArr.push(version)
        }
        this.selectedCollectionVersion.set(collection.id, _.uniq(versionsArr))
      }).filter(_.identity) as any
    })
    // this.setSyncQueryParams()
  }

  @action selectAllCollectionVersions = (collectionId) => {
    const {vlp: {hierarchy: {selectedCollections}}, syncProgress, syncType} = this

    selectedCollections?.filter(c => c.id == collectionId)?.map(collection => {
      collection.versions.map((version)=>{
        const id = collectionId + uiConstants.SEPARATOR + version.id
        syncProgress?.byId?.delete(id)
        !this.selectedCollectionVersion.has(collection.id) && this.selectedCollectionVersion.set(collection.id, [])
        let versionsArr = this.selectedCollectionVersion.get(collection.id)
        if (syncType?.showOnlyDefault && _.includes(syncType?.default, version.name)) {
          versionsArr.push(version)
        }else{
          versionsArr.push(version)
        }
        this.selectedCollectionVersion.set(collection.id, _.uniq(versionsArr))
      }).filter(_.identity)
    })
    // this.setSyncQueryParams()
  }

  isEmptyCollectionVersionSelection = (collectionId = null)=>{
    if(collectionId){return this.selectedCollectionVersion?.get(collectionId)?.length > 0 ? false : true}
    let isEmpty = true
    this.selectedCollectionVersion?.forEach((versions, collectionId)=> {if(versions.length > 0){isEmpty = false}} )
    return isEmpty
  }

  @computed get syncType() {
    return this.workspaceConfig?.catalog?.sync
  }

  @computed get disableSyncButton(){
    const {inProgress, props: {isSyncIndex}, isEmptyCollectionVersionSelection} = useSyncIndicatorStore(),
      {syncType} = this
    return inProgress || (!isSyncIndex && (!syncType?.noVersionSync && !isEmptyCollectionVersionSelection()))
  }

  totalVersionsCount = (collectionId)=>{
    const {vlp: {hierarchy: {selectedCollections}}} = this
    return selectedCollections?.filter(c => c.id == collectionId).reduce((acc, collection)=>{
      return acc + (collection?.versions?.length ?? 0)
    }, 0)
  }

  totalSelectedCollectionVersionCount = (collectionId)=>{
    return this.selectedCollectionVersion.get(collectionId)?.length ?? 0
  }
  @computed get isMultiCollectionSync(){
    const {vlp: {hierarchy: {selectedCollections}}} = this
    if(selectedCollections.length > 1){
      return true
    }
    if(!this.isEmptyCollectionVersionSelection()) return true
    return false
  }

}

export const SyncIndicatorStoreContext = React.createContext<SyncIndicatorStore>(undefined)
export const useSyncIndicatorStore = () => useContext(SyncIndicatorStoreContext)

/// endregion

const SyncIndicatorProgressBar = observer<{id:string}>(function SyncIndicatorProgressBar({id}) {
  const store = useSyncIndicatorStore(),
    {strings, status, onCancelSync, isEmptyCollectionVersionSelection, isCurrentIndexSyncing} = store,
    {syncIndicator: {progress, stop}} = strings
    let percentage = 0
    const {syncProgress, vlp: {hierarchy: {selectedCollections}}} = store
    if(isEmptyCollectionVersionSelection() && !isCurrentIndexSyncing && selectedCollections.length > 0) {
      let pcent = 0
      selectedCollections.forEach((collection:IPlanCollection)=>{
        const status = syncProgress.byId.get(collection.id)
        pcent += status?.percent ?? 0
      })
      percentage = Math.floor(pcent/(selectedCollections.length))
    }
    else{
      percentage = status?.percent ? status?.percent > 100 ? 100 : status?.percent : 0
    }

  return <div className={css.progressBar}>
    <div className={css.progressText}>{progress}: {percentage}%</div>
    <DeterminateProgressBar width={100} percentage={percentage} progressBarType='linear' showProgressBar/>
    {status?.cancellable && <Button className={css.stop} onClick={()=>onCancelSync(id)} minimal intent="primary">{stop}</Button>}
  </div>
})

export const StopSyncButton = observer<{id:string}>(function StopSyncButton({id}) {
  const {strings, onCancelSync} = useSyncIndicatorStore(),
    {syncIndicator: {stop}} = strings

  return <div className={css.progressBar}>
    <Button className={css.stop} onClick={()=>onCancelSync(id)} minimal intent="primary">{stop}</Button>
  </div>
})

const SyncIndicatorLastSyncStatus = observer(function LastSyncStatus() {
  const {strings, props: {lastSyncTimeMap, itemId}, triggeredFrom} = useSyncIndicatorStore(),
    {syncIndicator: {lastSync: lastSyncString, empty, never}} = strings

  const lastSync = lastSyncTimeMap?.get(itemId) ?? null,
    lastSyncText = lastSync ? [lastSyncString, ': ', <TimeAgo key="last-sync" date={lastSync}/>] : lastSyncString+': '+ never
  if(triggeredFrom === 'hierarchy' || triggeredFrom === 'filter'){
    return null
  }
  return <Fragment>
    <div className={css.lastSync}>{lastSyncText}</div>
  </Fragment>
})

const SyncIndicatorTitle = observer(function SyncIndicatorTitle() {
  const {inProgress, onStartSync, disableSyncButton, title} = useSyncIndicatorStore()

  return (
    <Button
      intent='primary'
      data-type='SyncIndicator'
      minimal
      disabled={disableSyncButton}
      onClick={!inProgress && onStartSync}
      text={title}
    />
  )
})

interface ButtonGroupProps {
  collectionId: string
}

const SyncIndicatorButtonGroup = observer<ButtonGroupProps>(function SyncIndicatorButtonGroup({collectionId}) {
  const {vlp: {hierarchy: {selectedCollectionVersions}}, workspaces: {workspaceConfig: {catalog: {sync}}}} = useStores(),
    {selected,totalSelectedCollectionVersionCount,totalVersionsCount, selectNoneCollectionVersions, selectDefaultCollectionVersions, selectAllCollectionVersions, isEmptyCollectionVersionSelection, inProgress} = useSyncIndicatorStore()

  if (sync?.showVersions !== true) return null

  return <div className={css.buttonGroup}>
    <ButtonGroup>
      <Button disabled={inProgress} active={isEmptyCollectionVersionSelection(collectionId)} minimal text="None" onClick={()=>selectNoneCollectionVersions(collectionId)}/>
      {!sync?.showOnlyDefault && <Button disabled={inProgress} minimal
	                                     active={_.isEqual(selected?.slice()?.sort(), sync?.default?.slice()?.sort())}
	                                     text="Default"
	                                     onClick={selectDefaultCollectionVersions}/>}
      <Button disabled={inProgress}
              active={totalSelectedCollectionVersionCount(collectionId) === totalVersionsCount(collectionId) || (sync?.showOnlyDefault && selected?.length === sync?.default.length)}
              minimal
              text="All" onClick={()=> selectAllCollectionVersions(collectionId)}/>
    </ButtonGroup>
  </div>
})


const SyncIndicatorCollections = observer(function SyncIndicatorCollections() {
  const {vlp: {hierarchy: {selectedCollections}}} = useStores()

  // if (sync?.showVersions !== true) return null

  return <Menu className={css.syncMultiCollectionContainer}>
          {selectedCollections.map((c, i) => <SyncIndicatorCollection key={i} collection={c} />)}
        </Menu>
})

const SyncIndicatorCollection = observer<{collection?: IPlanCollection & any}>(function SyncIndicatorCollection({collection}) {
  const {catalog: {seasonSelectorsCatalog: ss}, workspaces: {workspaceConfig: {catalog: {sync}}}} = useStores(),
    showVersionSync = sync?.showVersions,
    {isEmptyCollectionVersionSelection} = useSyncIndicatorStore(),
  obsProps = useAsObservableSource({collection, isEmptySelection:isEmptyCollectionVersionSelection()}),
    {percentage, itemCount} = useVipLocalStore((ws) => new SyncIndicatorCollectionVersionStore(ws, obsProps))
  let versions:Array<IVersion>& any = _.uniqBy(collection?.versions, 'id')
  versions= ss?.collectionVersion?.sortBuckets(versions) ?? versions

  return <div key={collection.id} className={!showVersionSync ? css.collectionOnly : undefined}>
    <div className={css.collectionHeader}>
      { 
        isEmptyCollectionVersionSelection() && percentage >= 100 ? <Icon className={css.progressCircle} icon="tick-circle"/>: percentage > 0 ? <CircularProgress className={css.progressCircle} size={20} variant={percentage <=10 ? "indeterminate":"determinate"} value={percentage}/> : null
      }
    <Label className={css.headerLabel}>{collection.name}</Label>
      {
        showVersionSync === true && 
        <SyncIndicatorButtonGroup collectionId={collection.id}/>
      }
    </div>
      {
        showVersionSync === true && 
        <Collapse isOpen={true}>
          {versions.map((version, j) => <SyncIndicatorCollectionVersion key={j} version={version} collection={collection} isEmptySelection={isEmptyCollectionVersionSelection()}/>)}
        </Collapse>
      }
    <Divider/>
  </div>
})


export const HeaderSyncIndicator = observer<MyProps & HTMLProps<any>>(function HeaderSyncIndicator({className, location, lastSyncTimeMap, syncId, isSyncIndex, workspace, trigger, itemId, ...props}) {
  const obsProps = useAsObservableSource({syncId, isSyncIndex, location, workspace, trigger, itemId, lastSyncTimeMap}),
    store = useVipLocalStore((ws) => new SyncIndicatorStore(ws, obsProps))

  const {isLoading, inProgress, isMultiCollectionSync, isCurrentUserSyncing, isContentSyncing,
    tooltipTitle, triggeredFrom, onStartSync} = store,
    tabMenu = useVipFlexLayoutTabStore()
  // Was componentWillUnmount

  // useEffect(() => store.registerEffects(), [])

  useEffect(() => {store.setDefaultCollectionVersionSelection(null)},
            [])

  return (
    <SyncIndicatorStoreContext.Provider value={store}>
      <ErrorBoundaryToast>
        <div className={classNames(css.root, className)}
             data-in-progress={inProgress}
             {...props}
             data-type='HeaderSyncIndicator'>
          <Popover2
            position='bottom'
            interactionKind='click'
            //disabled={disablePopover}
            //showPopOver={!site.isSyncCollectionInProgress || syncItemId == selectedCollection?.exId}
            //disabled={!inProgress || }
            // disabled={triggeredFrom == 'library'}
            content={
                <div className={classNames(css.syncCollectionContainer)}>
                  {/* <ClearIcon className={classNames(Classes.POPOVER_DISMISS, css.syncCloseIcon)}/> */}
                  {triggeredFrom == 'hierarchy' && <SyncIndicatorCollections />}
                  {/* <SyncIndicatorVersions/> */}
                  <div className={css.syncCollectionTextContainer}>
                    {inProgress ? <SyncIndicatorProgressBar id={null}/> : <SyncIndicatorLastSyncStatus/>}
                    <SyncIndicatorTitle/>
                  </div>
                </div>
            }>
            <Tooltip2
              disabled={tabMenu != null}
              content={tooltipTitle}
              placement={location === 'header' ? 'bottom' : 'bottom'}
            >
              <div className={css.iconAndText}>
                <PrimaryIconButton
                  showOnHover
                  // onClick={!inProgress && triggeredFrom == 'library' && onStartSync}
                  disabled={isLoading || inProgress && (!isCurrentUserSyncing || !isContentSyncing)}
                  className={classNames(inProgress && (!isCurrentUserSyncing || !isContentSyncing) && css.disabledLook)}
                  icon={<AutoRenewAnimationIconComponent animateIcon={isContentSyncing && inProgress}/>}/>
                {location === 'menu' && <span>Sync Workspace</span>}
              </div>
            </Tooltip2>
          </Popover2>
        </div>
      </ErrorBoundaryToast>
    </SyncIndicatorStoreContext.Provider>
  )
})



// WEBPACK FOOTER //
// ./src/modules/syncIndicator/HeaderSyncIndicator.tsx